import { combineReducers } from 'redux-immutable';

import orderFlowReducer from '@core/utils/orderFlowReducer';
import { INIT_STORE } from '@shared/actionTypes';

import { MODULE_NAME as menuSearchModule } from '@shopDetails/pages/MenuSearch/constants';
import menuSearchReducer from '@shopDetails/pages/MenuSearch/reducer';

import { MODULE_NAME as sectionDetailsModule } from '@shopDetails/pages/SectionDetails/constants';
import sectionDetailsReducer from '@shopDetails/pages/SectionDetails/reducer';

import { MODULE_NAME as reviewsModule } from '@shopDetails/pages/Reviews/constants';
import reviewsReducer from '@shopDetails/pages/Reviews/reducer';

import ModuleStateModel from './model';
import { DATA_SUBMODULE_NAME } from './constants';

const initialState = ModuleStateModel;

function conversionDataReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STORE:
      return ModuleStateModel.mergeDeep(state);

    default:
      return state;
  }
}

export default combineReducers({
  [DATA_SUBMODULE_NAME]: orderFlowReducer(conversionDataReducer, initialState),
  [menuSearchModule]: menuSearchReducer,
  [sectionDetailsModule]: sectionDetailsReducer,
  [reviewsModule]: reviewsReducer,
});
